import { FooterMenuItem } from '@app/objects/CustomMenuItem';

const services: Array<FooterMenuItem> = [
	{
		path: 'https://www.lapoflove.com/our-services/veterinary-hospice',
		name: 'Veterinary Hospice',
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/our-services/in-home-euthanasia',
		name: 'In-Home Euthanasia',
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/our-services/aftercare',
		name: 'Aftercare',
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/our-services/telehospice',
		name: 'Telehospice',
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/our-services/pet-loss-support',
		name: 'Pet Loss Support',
		newTab: true,
	},
];

const resources: Array<FooterMenuItem> = [
	{
		path: 'https://www.lapoflove.com/resource-center',
		name: 'Resource Center',
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/pet-loss-support-resources',
		name: 'Pet Loss & Grief',
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/blog',
		name: 'Blog',
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/videos',
		name: 'Videos',
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/faq',
		name: 'FAQ',
		newTab: true,
	},
];

const communityChildren: Array<FooterMenuItem> = [
	{
		path: 'https://www.lapoflove.com/pet-memorial',
		name: 'Pet Memorials',
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/veterinarian-testimonials',
		name: 'Testimonials',
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/angel-fund',
		name: 'Angel Fund',
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/pet-loss-support-resources',
		name: 'Pet Loss Support',
		newTab: true,
	},
];

const aboutUs: Array<FooterMenuItem> = [
	{
		path: 'https://www.lapoflove.com/about-us/who-we-are',
		name: 'Who We Are',
		newTab: true,
	},
	{
		path: 'https://lapoflovejobs.workable.com',
		name: 'Join Our Team',
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/about-us/student-externship',
		name: 'Student Externship',
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/in-the-news/press-clippings',
		name: 'In the News',
		newTab: true,
	},
];

export const footerMenu: { [key: string]: Array<FooterMenuItem> } = {
	Services: services,
	Resources: resources,
	Community: communityChildren,
	'About Us': aboutUs,
};
